import { render } from "./ImagePolygonOutline.vue?vue&type=template&id=8d85e878&scoped=true&ts=true"
import script from "./ImagePolygonOutline.vue?vue&type=script&lang=ts"
export * from "./ImagePolygonOutline.vue?vue&type=script&lang=ts"

import "./ImagePolygonOutline.vue?vue&type=style&index=0&id=8d85e878&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d85e878"]])

export default __exports__